import { apiUrls } from '@http/api-urls'
import { httpService } from '@http/service'
import { consoleDebug, isDebug } from '@shared/pipes/is-debug'

import { ConsentType, ConsentTypePreview } from './model'

export const receiveConsentTypes = () => {
	if (isDebug()) {
		return consoleDebug('[Sign form] - prevent send form')
	}

	return httpService.get<ConsentType[]>(apiUrls.esia.documents())
}

export const getConsentPreview = (documentId: string) => {
	if (isDebug()) {
		return consoleDebug('[Sign form] - prevent preview consent')
	}

	return httpService.get<ConsentTypePreview>(apiUrls.esia.document(documentId))
}
